import { openReactConfirmationDialog } from '~commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { Messages } from '~src/codegen/Localize';

export function openDeleteRoutingFilterConfirmationDialog(deleteRoutingFilter: () => void) {
  const dialogInstance = openReactConfirmationDialog({
    title: Messages.bridgeSiteSettingsDeleteRoutingFilter(),
    message: Messages.bridgeSiteSettingsDeleteRoutingFilterConfirmation(),
    paramsForAction: {},
    actionName: Messages.confirm(),
    action: () => {
      deleteRoutingFilter();
      return Promise.resolve();
    },
    isActionDelete: true,
    dialogWidth: TabDialogWidth.width375px
  });

  return dialogInstance.result;
}
